/** @format */
import { camelCase, camelCaseTransformMerge, snakeCase } from 'change-case';

export function toSnakeCase(key: string): string {
    return snakeCase(key, {
        transform: (input: string) => {
            const firstChar = input.charAt(0);
            const otherChars = input.substr(1).toLowerCase();
            return (
                '' +
                firstChar.toLowerCase() +
                otherChars.replace(/(\d+)$/, '_$1')
            );
        },
    });
}

export function toCamelCase<T = string>(key: string): T {
    return camelCase(key, {
        transform: camelCaseTransformMerge,
    }) as T;
}

/**
 * Recursively convert the key names of an object.
 *
 * @param object the object to convert
 * @param convert the conversion function
 */
export function convertKeyNames(
    object: any,
    convert: (name: string) => string
): any {
    if (object == null || typeof object !== 'object') {
        return object;
    }

    if (Array.isArray(object)) {
        return object.map((value) => convertKeyNames(value, convert));
    } else {
        const converted = {};
        Object.keys(object).forEach((key) => {
            if (Object.keys(object).includes(key)) {
                // @ts-ignore - Element implicitly has an any type - Touch and Change
                converted[convert(key)] = convertKeyNames(object[key], convert);
            }
        });
        return converted;
    }
}
